import { EntityImage } from '@tribeplatform/react-components/common/components'
import { convertIdToGlyph } from '@tribeplatform/react-components/MediaPicker'
import {
  type ActionBarAction,
  type ActionBarActionItem,
} from '@tribeplatform/react-components/Views'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const convertToActionItems = (
  actions: ActionBarAction[],
): ActionBarActionItem[] => {
  const actionItems = actions.map(action => {
    const { defaultLabel, glyphId } = action
    const actionItem: ActionBarActionItem = {
      ...action,
      itemIcon: glyphId ? (
        <EntityImage
          entity={{
            image: convertIdToGlyph(glyphId),
            name: defaultLabel ?? '',
          }}
          size="lg"
          displayColor={action.color}
        />
      ) : (
        <SvgIcon name="emotion" size="lg" />
      ),
    }

    return actionItem
  })

  return actionItems
}

export const convertToActions = (
  actionItems: ActionBarActionItem[],
): ActionBarAction[] => {
  const actions = actionItems.map(actionItem => {
    const { itemIcon: _itemIcon, ...action } = actionItem

    return action
  })

  return actions
}
